export const FILE_BASE_URL =
  "https://swmp2devapi.vmaxtechservices.life/swmp2images/";

// // // //Dotnet Base
// export const API_BASE_URL1 = "https://swmp2devapi.vmaxtechservices.help/v1/";
// export const API_BASE_URL3 = "https://swmp2devapi.vmaxtechservices.help/v2/";
// export const API_BASE_URL = "https://swmp2devapi.vmaxtechservices.help/";


//production URL
export const API_BASE_URL1 = "https://cure.swachhcity.com/cureapi/v1/";
export const API_BASE_URL3 = "https://cure.swachhcity.com/cureapi/v2/";

export const API_BASE_URL = "https://cure.swachhcity.com/cureapi/";


// export const API_BASE_URL1 = "https://localhost:7172/v1/";;
// export const API_BASE_URL3 = "https://localhost:7172/v2/";

// export const API_BASE_URL = "https://localhost:7172/"

//export const googleMapsApiKey11 = "AIzaSyAmek9bF8SnmFeUH4BvEffHYu_TuUieoDw";

//GOOGLE MAP
export const googleMapsApiKey11 = "AIzaSyAmek9bF8SnmFeUH4BvEffHYu_TuUieoDw";
